import "../scss/main.scss";
import "./auth";
import { initProfile } from "./profile/main";

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initProfile);
} else {
    initProfile();
}
